import React, { useMemo } from 'react'
import t from '~t'
import { useSelector } from 'react-redux'
import { getSearchEmpty } from '~data/selectors/bookmarks'
import { makeCollection } from '~data/selectors/collections'

export default function BookmarksHeaderSelectModeTitle({ selectMode = {} }) {
    const getCollection = useMemo(() => makeCollection(), [])
    const collection = useSelector(state => getCollection(state, selectMode.spaceId))
    const isSearching = useSelector(state => !getSearchEmpty(state, selectMode.spaceId))

    return (
        <>
            {selectMode.all ? t.s('all') : selectMode.ids.length}&nbsp;
            {isSearching
                ? (t.s('found').toLowerCase() + ' ' + t.s('bookmarks'))
                : (collection._id ? t.format('inCollectionName', collection.title) : '')
            }
        </>
    )
}
